module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <div class=\"col-md-12 nopadding-r\">\r\n        <div id=\"propTextTitle\" class=\"col-xs-2 nopadding\" style=\"margin-right: 5px; float:left; width: 65px; min-width: 65px;\">Text</div>\r\n        <div id=\"propTextAlignment\" class=\"col-xs-7 nopadding\">\r\n            <img id=\"align-left\" name=\"align-left\" src=\"")
    ; __append( require('editor/icons/align_left.png') )
    ; __append("\" style=\"background-color: ")
    ; __append(escapeFn( gridData[selectedRowId].attributes.alignLeftSelection ))
    ; __append("\" />\r\n            <img id=\"align-center\" name=\"align-center\" src=\"")
    ; __append( require('editor/icons/align_center.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( gridData[selectedRowId].attributes.alignCenterSelection ))
    ; __append("\" />\r\n            <img id=\"align-right\" name=\"align-right\" src=\"")
    ; __append( require('editor/icons/align_right.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( gridData[selectedRowId].attributes.alignRightSelection ))
    ; __append("\" />\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 nopadding-r\">\r\n        <input name=\"text\" type=\"text\" value=\"")
    ; __append(escapeFn( gridData[selectedRowId].attributes.text ))
    ; __append("\" ></input>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-65\">Max Chars</label> \r\n        <div style=\"display: inline-flex;\">\r\n           <input type=\"text\" name=\"maxChars\" style=\"width:45px;\" value=\"")
    ; __append(escapeFn( gridData[selectedRowId].attributes.maxChars ))
    ; __append("\" />\r\n        </div>   \r\n    </div>\r\n\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-65\">Format</label> \r\n        <div style=\"display: inline-flex;\">\r\n            <select id=\"format\" name=\"format\" >\r\n                <option value=\"normal\">None</option>\r\n                <option value=\"alpha\">Alpha</option>\r\n                <option value=\"numeric\">Numeric</option>\r\n                <option value=\"alphanumeric\">Alphanumeric</option>\r\n                <option value=\"text\">Text</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}